// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, userProfilePayload, validLicenceNumber, validPhone } from '../../../constants/globalConstants'
// import VehicleAndPermit from '../vehicleAndPermit/VehicleAndPermit'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { fileChangedHandler, isLoggedIn, isPermissionExist, restrictSpecialChar, sortPortalPermissionByKey, validateEmail } from '../../../utils/helper'
// validatePhone
import { updateUserProfile, getUserProfile } from '../../../redux/actions/login'
import FileUpload from '../../../components/fileUpload/FileUpload'
import { Circles } from 'react-loader-spinner'
import ResetPassWordModal from '../../../components/global/ResetPassWordModal'
// import MessageModal from '../../../components/global/MessageModal'
import debounce from 'lodash/debounce'
// import { getVehicleDataList, getVehicleDetailsList } from '../../redux/actions/VehicleListAction'
// import {getVehicleDetailsList}  from '../../../redux/actions/VehicleListAction'
import { getVehicleDetailsList, getVehicleModelList } from '../../../redux/actions/VehicleListAction'

// import URL from '../../../constants/urls'
// const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
const zipCodeMaskGenerator = createDefaultMaskGenerator('999999')

function UserProfile(props) {
    const { dispatch, partnerDetails, countryData, stateData, notify } = props
    const navigate = useNavigate()

    const [idProof, setIdProof] = useState(EMPTY_OBJECT)
    const [images, setImages] = useState({})
    const [userData, setUserData] = useState(EMPTY_OBJECT)
    const [edit, setEdit] = useState(false)
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState(EMPTY_OBJECT)
    const [resident, setResident] = useState('')
    const [userUpdatePayload, setUserUpdatePayload] = useState(userProfilePayload)
    const [disclaimerNote, setDisclaimerNote] = useState('')
    const [isUpdatingProfile, setIsUpdatingProfile] = useState(false)

    // modal state 
    const [isResetModalOpen, setResetModalOpen] = useState(false)
    const [accessPermissions, setAccessPermissions] = useState('')
    const [isConsent, setIsConsent] = useState(true)
    const [isAutoCheckout, setIsAutoCheckout] = useState(false)
    const [stateList, setStateList] = useState(stateData)
    // const [displayModal, setDisplayModal] = useState(false)


    // 
    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
        // dispatch(getVehicleDetailsList(partnerDetails?.facilities?.[0]?.country_code)).then(() => {})
    }, [EMPTY_ARRAY, partnerDetails])

    // useEffect(() => {
    //     if (partnerDetails?.id) {
    //         let countryList=[partnerDetails?.facilities?.[0]?.country_code]
    //         console.log('ppp',isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode'))
    //         if(isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode')){
    //              countryList=[partnerDetails?.facilities?.[0]?.country_code,'CA']
    //         }
    //         dispatch(getVehicleDetailsList(countryList)).then(() => {
    //             userUpdatePayload['country'] = countryData ? countryData?.[1]?.name : 'United States'
    //             setUserUpdatePayload({ ...userUpdatePayload }) 
    //         })
    //     }
    // }, [EMPTY_ARRAY, partnerDetails])

    useEffect(() => {

        if (idProof?.front) {
            const front = idProof?.front ? URL.createObjectURL(idProof?.front) : ''
            setImages({ ...images, front: front })
        }

    }, [idProof?.front])
    useEffect(() => {
        if (idProof?.back) {
            const back = idProof?.back ? URL.createObjectURL(idProof?.back) : ''
            setImages({ ...images, back: back })
        }

    }, [idProof?.back])

    useEffect(() => {



        if (!isLoggedIn()) {
            navigate('/')
        }
        dispatch(getUserProfile()).then((res) => {
            if (res) {
                setResident(res?.resident_status)
                const userProfileData = JSON.parse(localStorage.getItem('userData'))
                userProfileData.user = res
                if (userProfileData) {
                    localStorage.setItem('userData', JSON.stringify(userProfileData))
                } else {
                    localStorage.setItem('userData', '{}')
                }
                setIsConsent(res?.user_consent == '1' ? true : false)
                setIsAutoCheckout(res?.is_auto_checkout_enabled == '1' ? true : false)
                setUserData(res)
                images['front'] = res?.permit?.[0]?.idfront
                images['back'] = res?.permit?.[0]?.idback
                setImages({ ...images })
                // let countryList=[partnerDetails?.facilities?.[0]?.country_code]
                let countryList = [partnerDetails?.facilities?.[0]?.country_code, 'CA', 'GB']
                if (isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode')) {
                    countryList = [partnerDetails?.facilities?.[0]?.country_code, 'CA', 'GB']
                }
                dispatch(getVehicleDetailsList(countryList)).then((responce) => {
                    getStateByCountry(res?.country, responce?.country ? responce?.country : countryData)
                })

                // dispatch(getVehicleDetailsList(res?.country ? res?.country : partnerDetails?.facilities?.[0]?.country_code)).then(() => {})
                // if (res?.name !== '') {
                const formdata = res
                userUpdatePayload['name'] = formdata?.name ? formdata?.name?.trim() : ''
                userUpdatePayload['license_number'] = formdata?.license_number ? formdata?.license_number?.trim() : res?.license_number ? res?.license_number : ''
                userUpdatePayload['email'] = formdata?.email ? formdata?.email?.trim() : ''
                userUpdatePayload['phone'] = formdata?.phone_number ? formdata?.phone_number?.trim() : ''
                userUpdatePayload['address'] = formdata?.address ? formdata?.address?.trim() : ''
                userUpdatePayload['address2'] = formdata?.address2 ? formdata?.address2?.trim() : ''
                userUpdatePayload['company_name'] = formdata?.company_name ? formdata?.company_name?.trim() : ''
                userUpdatePayload['country'] = formdata?.country ? formdata?.country?.trim() : ''
                userUpdatePayload['user_prefrences'] = formdata?.user_prefrences ? formdata?.user_prefrences?.trim() : ''
                userUpdatePayload['city'] = formdata?.city ? formdata?.city?.trim() : ''
                userUpdatePayload['state'] = formdata?.state ? formdata?.state?.trim() : ''
                userUpdatePayload['zipcode'] = formdata?.pincode ? formdata?.pincode?.trim() : ''
                userUpdatePayload['user_prefrences'] = formdata?.user_prefrences ? formdata?.user_prefrences == '0' ? 3 : formdata?.user_prefrences?.trim() : ''
                setUserUpdatePayload({ ...userUpdatePayload })
                // }
            }
        })
    }, [EMPTY_OBJECT])

    const handleInputChange = (e) => {
        const { name, value } = e.target
        if (name == 'license_number') {
            userUpdatePayload[name] = value?.trim()?.toUpperCase()
            setUserUpdatePayload({ ...userUpdatePayload })

            if (value?.length > 6 && value?.length < 14) {
                if (value?.length != 9) {
                    if (validLicenceNumber.test(value?.trim())) {
                        setResident('Non-Resident')
                    } else {
                        setResident('Invalid License Number')
                    }
                } else {
                    const alpha = value?.slice(0, 1)
                    const number = value?.slice(1, 9)
                    if (/^[a-zA-Z]+$/.test(alpha) && /(\d{8})/g.test(number)) {
                        setResident('Resident')
                    } else {
                        if (validLicenceNumber.test(value?.trim())) {
                            setResident('Non-Resident')
                        } else {
                            setResident('Invalid License Number')
                        }
                    }
                }
            } else {
                setResident('')
            }
            if (userData?.license_number != value) {
                setDisclaimerNote('For New/Existing Permits, the revised rates will be applicable as per your new License number.')
            } else {
                setDisclaimerNote('')
            }
        } else {
            userUpdatePayload[name] = value?.trim()
            setUserUpdatePayload({ ...userUpdatePayload })
        }
    }
    const handlecountryChange = (e) => {
        const { name, value } = e.target
        getStateByCountry(value, countryData)
        userUpdatePayload[name] = value?.trim()
        setUserUpdatePayload({ ...userUpdatePayload })
    }
    const getStateByCountry = (value, countryList = '') => {
        let countryDatas = countryList?.filter((v) => v.country_code == value || v.name == value)
        dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code, countryDatas?.[0]?.id)).then((res) => {

            setStateList(res?.state)
            userUpdatePayload['country'] = value?.trim()
            setUserUpdatePayload({ ...userUpdatePayload })
            //  setValue('country', value)     
        })

    }

    const handleLicenseChange = (e) => {
        const { value } = e.target

        if (userData?.license_number != value) {
            setDisclaimerNote('For New/Existing Permits, the revised rates will be applicable as per your new License number.')
        } else {
            setDisclaimerNote('')
        }
    }

    // const handlePhoneChange = (value) => {
    //     setUserUpdatePayload({ ...userUpdatePayload, ['phone']: value?.trim() })
    // }

    const handleZipCodeChange = (value) => {

        setUserUpdatePayload({ ...userUpdatePayload, ['zipcode']: value?.trim() })
    }

    const handleUserPrefrenceChange = (e) => {
        const { value } = e.target
        setUserUpdatePayload({ ...userUpdatePayload, ['user_prefrences']: value?.trim() })
    }

    const handleEditMode = () => {
        setEdit(true)
    }

    const handleUpdateUserProfile = (e) => {
        setError(true)
        setIsUpdatingProfile(true)
        e.preventDefault()
        let formData = new FormData()     //formdata object
        formData.append('license_number', userUpdatePayload?.license_number ? userUpdatePayload?.license_number : '')
        formData.append('email', userUpdatePayload?.email ? userUpdatePayload?.email : '')
        formData.append('name', userUpdatePayload?.name ? userUpdatePayload?.name : '')
        formData.append('phone', userUpdatePayload?.phone ? userUpdatePayload?.phone : '')
        formData.append('address', userUpdatePayload?.address ? userUpdatePayload?.address : '')
        formData.append('address2', userUpdatePayload?.address2 ? userUpdatePayload?.address2 : '')
        formData.append('company_name', userUpdatePayload?.company_name ? userUpdatePayload?.company_name : '')
        formData.append('user_prefrences', userUpdatePayload?.user_prefrences ? userUpdatePayload?.user_prefrences : '')
        formData.append('country', userUpdatePayload?.country ? userUpdatePayload?.country : '')
        formData.append('city', userUpdatePayload?.city ? userUpdatePayload?.city : '')
        formData.append('state', userUpdatePayload?.state ? userUpdatePayload?.state : '')
        formData.append('zipcode', userUpdatePayload?.zipcode ? userUpdatePayload?.zipcode : '')
        formData.append('image_front', idProof?.front ? idProof?.front : '')
        formData.append('image_back', idProof?.back ? idProof?.back : '')
        formData.append('permit_id', userData?.permit?.[0]?.id ? userData?.permit?.[0]?.id : '')

        if (userUpdatePayload?.name != '' && userUpdatePayload?.email != '' && userUpdatePayload?.phone != '' && userUpdatePayload?.address != '' && userUpdatePayload?.city != '' && userUpdatePayload?.state != '' && userUpdatePayload?.zipcode != '' && userUpdatePayload?.country != '') {
            if (validateEmail(userUpdatePayload?.email)) {
                if (validPhone.test(userUpdatePayload?.phone) && userUpdatePayload?.phone?.length == 10 && userUpdatePayload?.zipcode?.length > 4 && userUpdatePayload?.zipcode?.length <= 6) {
                    // if (validLicenceNumber.test(userUpdatePayload?.license_number?.trim())) {
                    dispatch(updateUserProfile(formData)).then((res) => {
                        if (res?.data) {
                            notify('success', 'Profile updated successfully!')
                            setIsUpdatingProfile(false)
                            setDisclaimerNote('')
                            const userProfileData = JSON.parse(localStorage.getItem('userData'))
                            userProfileData.user = res?.data?.user
                            userProfileData.permit = res?.data?.permit
                            if (userProfileData) {
                                if (res?.data?.permit?.idfront || res?.data?.permit?.idback) {
                                    images['front'] = res?.data?.permit?.idfront ? res?.data?.permit?.idfront : ''
                                    images['back'] = res?.data?.permit?.idback ? res?.data?.permit?.idback : ''
                                    setImages({ ...images })
                                }
                                localStorage.setItem('userData', JSON.stringify(userProfileData))
                            } else {
                                localStorage.setItem('userData', '{}')
                            }
                            setEdit(false)
                        } else {
                            setIsUpdatingProfile(false)
                            notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
                            // setErrorMessage({ message: 'Something went wrong, Please try again!' })
                        }

                    }).catch(() => {
                        setDisclaimerNote('')
                        setIsUpdatingProfile(false)
                        setErrorMessage({ message: 'Something went wrong, Please try again!' })
                    })
                    // } else {
                    //     setIsUpdatingProfile(false)
                    //     setErrorMessage({ message: '' })
                    // }

                } else {
                    setIsUpdatingProfile(false)
                    setErrorMessage({ message: '' })
                }
            } else {
                setIsUpdatingProfile(false)
                setErrorMessage({ message: '' })
            }

        } else {
            setIsUpdatingProfile(false)
            setErrorMessage({ message: '' })
        }
    }

    // modal functions

    const handleModalOpen = (e) => {
        e.preventDefault()
        setResetModalOpen(true)
    }

    const handleAutoPayChange = () => {

        setIsConsent(!isConsent)
        let formData = new FormData()     //formdata object
        formData.append('license_number', userUpdatePayload?.license_number ? userUpdatePayload?.license_number : '')
        formData.append('email', userUpdatePayload?.email ? userUpdatePayload?.email : '')
        formData.append('name', userUpdatePayload?.name ? userUpdatePayload?.name : '')
        if (userData?.phone_number != userUpdatePayload?.phone) {
            formData.append('phone', userUpdatePayload?.phone ? userUpdatePayload?.phone : '')
        }
        formData.append('address', userUpdatePayload?.address ? userUpdatePayload?.address : '')
        formData.append('address2', userUpdatePayload?.address2 ? userUpdatePayload?.address2 : '')
        formData.append('city', userUpdatePayload?.city ? userUpdatePayload?.city : '')
        formData.append('country', userUpdatePayload?.country ? userUpdatePayload?.country : '')
        formData.append('company_name', userUpdatePayload?.company_name ? userUpdatePayload?.state : '')
        formData.append('state', userUpdatePayload?.state ? userUpdatePayload?.state : '')
        formData.append('zipcode', userUpdatePayload?.zipcode ? userUpdatePayload?.zipcode : '')
        formData.append('image_front', idProof?.front ? idProof?.front : '')
        formData.append('image_back', idProof?.back ? idProof?.back : '')
        formData.append('permit_id', userData?.permit?.[0]?.id ? userData?.permit?.[0]?.id : '')
        formData.append('user_consent', !isConsent ? 1 : 0)
        formData.append('is_auto_checkout_enabled', isAutoCheckout ? 1 : 0)

        deb(formData)


    }

    const handleAutoCheckoutChange = () => {

        setIsAutoCheckout(!isAutoCheckout)
        let formData = new FormData()     //formdata object
        formData.append('license_number', userUpdatePayload?.license_number ? userUpdatePayload?.license_number : '')
        formData.append('email', userUpdatePayload?.email ? userUpdatePayload?.email : '')
        formData.append('name', userUpdatePayload?.name ? userUpdatePayload?.name : '')
        formData.append('phone', userUpdatePayload?.phone ? userUpdatePayload?.phone : '')
        formData.append('address', userUpdatePayload?.address ? userUpdatePayload?.address : '')
        formData.append('address2', userUpdatePayload?.address2 ? userUpdatePayload?.address2 : '')
        formData.append('city', userUpdatePayload?.city ? userUpdatePayload?.city : '')
        formData.append('country', userUpdatePayload?.country ? userUpdatePayload?.country : '')
        formData.append('company_name', userUpdatePayload?.company_name ? userUpdatePayload?.state : '')
        formData.append('state', userUpdatePayload?.state ? userUpdatePayload?.state : '')
        formData.append('zipcode', userUpdatePayload?.zipcode ? userUpdatePayload?.zipcode : '')
        formData.append('image_front', idProof?.front ? idProof?.front : '')
        formData.append('image_back', idProof?.back ? idProof?.back : '')
        formData.append('permit_id', userData?.permit?.[0]?.id ? userData?.permit?.[0]?.id : '')
        formData.append('user_consent', isConsent ? 1 : 0)
        formData.append('is_auto_checkout_enabled', !isAutoCheckout ? 1 : 0)

        deb(formData)


    }

    const deb = useCallback(
        debounce((payload) => {
            dispatch(updateUserProfile(payload)).then((res) => {
                // notify('success', 'Autopay settings updated')
                if (res?.data) {
                    notify('success', 'Autopay settings updated')
                } else {
                    notify('error', res?.errors ? res?.errors?.message : 'Something went wrong, Please try again!')
                }
                setIsUpdatingProfile(false)
                setDisclaimerNote('')
                const userProfileData = JSON.parse(localStorage.getItem('userData'))
                userProfileData.user = res?.data?.user
                userProfileData.permit = res?.data?.permit
                if (userProfileData) {
                    if (res?.data?.permit?.idfront || res?.data?.permit?.idback) {
                        images['front'] = res?.data?.permit?.idfront ? res?.data?.permit?.idfront : ''
                        images['back'] = res?.data?.permit?.idback ? res?.data?.permit?.idback : ''
                        setImages({ ...images })
                    }
                    localStorage.setItem('userData', JSON.stringify(userProfileData))

                } else {
                    localStorage.setItem('userData', '{}')
                }
                setEdit(false)
            }).catch(() => {
                notify('error', 'Something went wrong, Please try again!')
                setDisclaimerNote('')
                setIsUpdatingProfile(false)
                setErrorMessage({ message: 'Something went wrong, Please try again!' })
            })
        }, 300
        ), [])

    return (
        <main>
            <section className="formDesign">
                {/* <VehicleAndPermit userData={userData} /> */}
                <div className="container mb-3">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="d-flex">
                                <h5 className="mb-0">Personal Information</h5>
                                <button className="btn btn-primary p-0 px-2 ms-auto me-1" type='button' onClick={(e) => handleModalOpen(e)}>Reset Password</button>
                                <button className="btn btn-secondary p-0 px-2" onClick={handleEditMode}> <i className="fa fa-pencil"></i></button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name <span style={{ color: 'red' }}>*</span></label>
                                        <input className="form-control" maxLength={20} name='name' id='name' type='text' value={userData?.name ? userData?.name : ''} disabled />
                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.name ? 'This field is required' : ''}</span>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email <span style={{ color: 'red' }}>*</span></label>
                                        <input className="form-control" maxLength={40} id='email' name='email' type='email' value={userData?.email ? userData?.email : ''} disabled />
                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.email ? 'This field is required' : ''}</span>
                                    </div>
                                </div>

                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Phone Number <span style={{ color: 'red' }}>*</span></label>
                                        <input className="form-control" maxLength={40} id='phone' name='phone' type='number' onChange={handleInputChange} onBlur={handleInputChange} defaultValue={userData?.phone_number ? userData?.phone_number : ''} disabled={!edit} />
                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.email ? 'This field is required' : ''}</span>
                                    </div>
                                </div>
                                {/* <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Phone Number <span style={{ color: 'red' }}>*</span></label>
                                        <MaskedInput
                                            maskGenerator={phoneMaskGenerator}
                                            value={userData?.phone_number ? userData?.phone_number : ''}
                                            type="text"
                                            name="phone"
                                            id="phone"
                                            className="form-control"
                                            required
                                            maxLength={14}
                                            minLength={14}
                                            title="Please enter a valid phone number"
                                            onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                            onInput={e => e.target.setCustomValidity('')}
                                            placeholder="Phone Number"
                                            onChange={handlePhoneChange}
                                            // onBlur={handlePhoneChange}
                                            disabled={!edit}
                                        />
                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.phone ? 'This field is required' : ''}</span>
                                        <span className="form-text text-danger h-40">{error && userUpdatePayload?.phone.length < 10 ? 'Minimum 10 characters allowed' : ''}</span>
                                        <span className="form-text text-danger h-40">{error && userUpdatePayload?.phone.length > 10 ? 'Maximum 10 characters allowed' : ''}</span>

                                    </div>
                                </div> */}

                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="company_name" className="form-label">Company Name </label>
                                        <input className="form-control" maxLength={20} name='company_name' id='company_name' defaultValue={userData?.company_name ? userData?.company_name : ''} onChange={handleInputChange} onBlur={handleInputChange} disabled={!edit} />
                                        {/* <span className="form-text text-danger h-40">{error && !userUpdatePayload?.company_name ? 'This field is required' : ''}</span> */}
                                    </div>
                                </div>

                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="address" className="form-label">Address <span style={{ color: 'red' }}>*</span></label>
                                        <input className="form-control" maxLength={100} id='address' name='address' defaultValue={userData?.address ? userData?.address : ''} onChange={handleInputChange} onBlur={handleInputChange} disabled={!edit} />
                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.address ? 'This field is required' : ''}</span>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="address2" className="form-label">Address 2</label>
                                        <input className="form-control" maxLength={100} id='address2' name='address2' defaultValue={userData?.address2 ? userData?.address2 : ''} onChange={handleInputChange} onBlur={handleInputChange} disabled={!edit} />
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="city" className="form-label">City <span style={{ color: 'red' }}>*</span></label>
                                        <input className="form-control" maxLength={20} name='city' id='city' defaultValue={userData?.city ? userData?.city : ''} onChange={handleInputChange} onBlur={handleInputChange} disabled={!edit} />
                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.city ? 'This field is required' : ''}</span>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="country" className="form-label">Country <span style={{ color: 'red' }}>*</span></label>
                                        {/* <input className="form-control" maxLength={20} name='country' id='country' defaultValue={userData?.country ? userData?.country : ''} onChange={handleInputChange} onBlur={handleInputChange} disabled={!edit} /> */}
                                        <select type="select" className='form-select' name='country' id='country' onChange={handlecountryChange} onBlur={handleInputChange} disabled={!edit}  >
                                            <option value=''>Select Country</option>
                                            {countryData?.map((item, index) => <option key={(index + 1)} selected={item?.name == userData?.country || item?.country_code == userData?.country} value={item?.name} >{item?.name}</option>)}
                                        </select>
                                        {/* {errors?.country?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>} */}

                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.country ? 'This field is required' : ''}</span>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="state" className="form-label">State <span style={{ color: 'red' }}>*</span></label>
                                        {/* <input className="form-control" maxLength={20} name='state' id='state' defaultValue={userData?.state ? userData?.state : ''} onChange={handleInputChange} onBlur={handleInputChange} disabled={!edit} /> */}
                                        <select className='form-select' name="state" id='state' onChange={handleInputChange} onBlur={handleInputChange} disabled={!edit} >
                                            <option value=''>Select State</option>
                                            {stateList?.map((item, itemIndex) => <option key={(itemIndex + 1)} selected={item?.id == userData?.state || item?.state_code == userData?.state} value={item?.id}>{item?.state_code}</option>)}
                                        </select>
                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.state ? 'This field is required' : ''}</span>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="zipcode" className="form-label"> Zip/Postal Code <span style={{ color: 'red' }}>*</span></label>
                                        <MaskedInput
                                            maskGenerator={isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? '' : zipCodeMaskGenerator}
                                            value={userData?.pincode ? userData?.pincode : ''}
                                            type="text"
                                            name="zipcode"
                                            id="zipcode"
                                            className="form-control"
                                            required
                                            // pattern="[0-9 \\-\(\)\]{14}"
                                            maxLength={6}
                                            minLength={5}
                                            title="Please enter a valid zipcode"
                                            onInvalid={e => e.target.setCustomValidity('Please enter zipcode')}
                                            onInput={e => e.target.setCustomValidity('')}
                                            placeholder="Enter Zip/Postal Code"
                                            onChange={handleZipCodeChange}
                                            disabled={!edit}
                                        />
                                        <span className="form-text text-danger h-40">{error && !userUpdatePayload?.zipcode ? 'This field is required' : ''}</span>
                                        <span className="form-text text-danger h-40">{error && userUpdatePayload?.zipcode && userUpdatePayload?.zipcode.length < 5 ? isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Minimum 5 characters allowed' : 'Minimum 5 numbers allowed' : ''}</span>
                                        <span className="form-text text-danger h-40">{error && userUpdatePayload?.zipcode && userUpdatePayload?.zipcode.length > 6 ? isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? 'Maximum 6 characters allowed' : 'Maximum 6 numbers allowed' : ''}</span>

                                    </div>
                                </div>
                            </div>
                            {/* <hr /> */}
                            {!isPermissionExist(accessPermissions, 'Driving License') ?
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div>
                                            <label htmlFor="license_number" className="form-label">Driver License Number <span style={{ color: 'red' }}>*</span></label>
                                            <input
                                                className="form-control"
                                                name='license_number'
                                                id='license_number'
                                                type='text'
                                                value={userUpdatePayload?.license_number ? userUpdatePayload?.license_number : ''}
                                                minLength={7}
                                                maxLength={13}
                                                // defaultValue={userData?.license_number ? userData?.license_number : ''} 
                                                onChange={handleInputChange}
                                                onKeyDown={restrictSpecialChar}
                                                onBlur={handleLicenseChange}
                                                disabled={!edit} />
                                        </div>
                                        {resident ? <span className={resident == 'Invalid License Number' ? 'd-block form-text text-danger h-40 text-end' : 'd-block form-text text-primary h-40 text-end'}><b>{resident}</b></span> : ''}
                                        <span className="d-block form-text text-danger h-40">{error && !userUpdatePayload?.license_number ? 'This field is required' : ''}</span>
                                        {disclaimerNote && userUpdatePayload?.license_number ? <span className='text-danger'><small>{disclaimerNote}</small></span> : ''}
                                    </div>
                                    <div className="col text-center ">
                                        <b>Drivers License Proof (Front)</b>
                                        {images?.front ? <div className="p-1 text-center"> <img height="46px" src={images?.front} /></div> : <div className="p-1 text-center">-</div>}
                                    </div>
                                    <div className="col text-center ">
                                        <b>Drivers License Proof (Back)</b>
                                        {images?.back ? <div className="p-1 text-center"> <img height="46px" src={images?.back} /></div> : <div className="p-1 text-center">-</div>}
                                    </div>
                                    {edit ?
                                        <div className="row">
                                            <FileUpload
                                                accept='image/*'
                                                onChange={(event) => fileChangedHandler(event, 'front', setIdProof, idProof, 300, 200)}
                                                name='front'
                                                id='front'
                                                required />
                                            <FileUpload
                                                accept='image/*'
                                                onChange={(event) => fileChangedHandler(event, 'back', setIdProof, idProof, 300, 200)}
                                                name='back'
                                                id='back'
                                                required />
                                            <small>
                                                (File type : jpeg, jpg, png)
                                            </small>
                                        </div>
                                        : null}
                                </div> : null}
                            <hr />

                            {isPermissionExist(accessPermissions, 'User Preference') ? <div className="container p-0">
                                <h4 className="mb-3 font-light">User Preference</h4>
                                <div className='clearfix'>
                                    <label htmlFor="user_prefrences" >Send Reservation Confirmation </label>

                                    <div className='d-flex gap-4'>
                                        <span>
                                            <input type="radio" disabled={!edit} id='user_prefrences1' value='2' name='user_prefrences' checked={userUpdatePayload?.user_prefrences == '2' ? true : false} onChange={(e) => handleUserPrefrenceChange(e)} />
                                            <span className='pl-2' > Via Email</span>
                                        </span>

                                        <span >
                                            <input type="radio" disabled={!edit} id='user_prefrences2' value='1' name='user_prefrences' defaultChecked={true} checked={userUpdatePayload?.user_prefrences == '1' ? true : false} onChange={(e) => handleUserPrefrenceChange(e)} />
                                            <span className='pl-2' > Via SMS</span>
                                        </span>

                                        <span >
                                            <input type="radio" disabled={!edit} id='user_prefrences3' value='3' name='user_prefrences' checked={userUpdatePayload?.user_prefrences == '3' || userUpdatePayload?.user_prefrences == '0' ? true : false} onChange={(e) => handleUserPrefrenceChange(e)} />
                                            <span className='pl-2'> Via Both Email/SMS</span>
                                        </span>
                                    </div>

                                </div>

                            </div> : ''}

                            {errorMessage ? <span className='text-danger'>{errorMessage?.message ? errorMessage?.message : ''}</span> : ''}
                            {edit && <button type="button" className="btn btn-primary d-flex" onClick={(e) => handleUpdateUserProfile(e)} style={{ float: 'right' }}>Update {isUpdatingProfile ? <span className=' ms-2'><Circles
                                height="20"
                                width="20"
                                color="#ffffff"
                                ariaLabel="circles-loading"
                                visible={true}
                            /></span> : null}
                            </button>}
                        </div>
                    </div>
                    {isPermissionExist(accessPermissions, 'AutoPay Settings') || isPermissionExist(accessPermissions, 'LPR Auto checkout') ? <div className="container p-0">
                        <div className="card">
                            <div className="card-header">
                                <div className="d-flex">
                                    <h5 className="mb-0">AutoPay Settings</h5>
                                </div>
                            </div>
                            <div className='card-body'>
                                <div className="row">
                                    {isPermissionExist(accessPermissions, 'AutoPay Settings') ? <>
                                        <div className="col-12 col-md-6 my-1">
                                            <span className="switch-wrap">
                                                <label className="switch">
                                                    <input type="checkbox" id='autopayconsent' name='autopayconsent' checked={isConsent} onChange={() => handleAutoPayChange()} />
                                                    <span className="slider round"></span>
                                                </label>
                                                <label htmlFor="autopayconsent" className='ps-2' > AutoPay Consent for Permit Renewal </label>
                                                {/* <i className='ps-2 fa-sm fa fa-info-circle' onClick={() => setDisplayModal(true)}></i> */}
                                            </span>
                                            <i className='d-block small'>By clicking this button, you are providing your consent for permit auto renewal.</i>


                                        </div>
                                    </> : null}
                                    {isPermissionExist(accessPermissions, 'LPR Auto checkout') ? <>
                                        <div className="col-12 col-md-6 my-1">
                                            <div className="row"></div>
                                            <span className="switch-wrap">
                                                <label className="switch">
                                                    <input type="checkbox" id='autocheckout' name='autocheckout' checked={isAutoCheckout} onChange={() => handleAutoCheckoutChange()} />
                                                    <span className="slider round"></span>
                                                </label>
                                                <label htmlFor="autocheckout" className='ps-2' > LPR Auto-Checkout </label>
                                                {/* <i className='ps-2 fa-sm fa fa-info-circle' onClick={() => setDisplayModal(true)}></i> */}
                                            </span>
                                            <i className='d-block small'>By clicking this button, you are providing your consent for LPR auto checkout.</i>
                                        </div>
                                    </> : null}
                                </div>
                            </div>
                        </div>
                    </div> : null}

                    {/* <div className="card">
                        <div className="card-header">
                            <div className="d-flex">
                                <h5 className="mb-0">Password</h5>
                                <button className="btn p-0 px-2 ms-auto"> <i className="fa fa-pencil"></i></button>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label">Password Old</label>
                                        <div className="form-control">********</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </section>

            <ResetPassWordModal isResetModalOpen={isResetModalOpen} setResetModalOpen={setResetModalOpen} modalHeader='Reset Password' buttonLable='Reset' notify={notify} navigate={navigate} />
            {/* <MessageModal setDisplayModal={setDisplayModal} displayModal={displayModal} modalHeading='Autopay Policy' modalMessage='Policy Message' /> */}

        </main>
    )
}


UserProfile.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    setFront: PropTypes.func,
    setBack: PropTypes.func,
    partnerDetails: PropTypes.object,
    notify: PropTypes.func,
    stateData: PropTypes.array,
    countryData: PropTypes.array
}

UserProfile.defaulProps = {
    dispatch: noop,
    loader: PropTypes.bool,
    setFront: noop,
    setBack: noop,
    partnerDetails: EMPTY_OBJECT,
    notify: noop,
    stateData: EMPTY_ARRAY,
    countryData: EMPTY_ARRAY
}
function mapStateToProps({ vehicleListReducer }) {

    return {
        stateData: vehicleListReducer?.data?.state,
        countryData: vehicleListReducer?.data?.country
    }
}
// function mapStateToProps() {
// }
export default connect(mapStateToProps)(UserProfile)